export function BrowserFrame({ src, alt, url = "www.koranex-concept.demo", className = "" }) {
  return (
    <div className={`rounded-xl border border-slate-800 bg-[#020617] overflow-hidden shadow-2xl ${className}`}>
      <div className="flex items-center gap-2 px-3 py-2.5 border-b border-slate-800 bg-[#0f172a]">
        <div className="flex gap-1.5">
          <span className="w-2.5 h-2.5 rounded-full bg-slate-700" />
          <span className="w-2.5 h-2.5 rounded-full bg-slate-700" />
          <span className="w-2.5 h-2.5 rounded-full bg-[#38bdf8]/60" />
        </div>
        <div className="flex-1 mx-2 px-3 py-1 rounded-md bg-[#020617] border border-slate-800 text-[10px] font-mono-x text-slate-500 truncate">
          {url}
        </div>
      </div>
      <img src={src} alt={alt} loading="lazy" className="w-full aspect-[16/10] object-cover object-top" />
    </div>
  );
}

export function PhoneFrame({ src, alt, className = "" }) {
  return (
    <div className={`rounded-[2rem] border border-slate-700 bg-[#0f172a] p-2 shadow-2xl ${className}`}>
      <div className="rounded-[1.6rem] overflow-hidden border border-slate-800 bg-[#020617] relative">
        <div className="absolute top-2 left-1/2 -translate-x-1/2 w-16 h-4 bg-[#0f172a] rounded-full z-10 border border-slate-800" />
        <img src={src} alt={alt} loading="lazy" className="w-full aspect-[9/18] object-cover object-top" />
      </div>
    </div>
  );
}

export function DeviceImage({ device, src, alt, className = "" }) {
  if (device === "phone") {
    return <PhoneFrame src={src} alt={alt} className={className} />;
  }
  if (device === "photo") {
    return (
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className={`w-full rounded-xl border border-slate-800 shadow-2xl ${className}`}
      />
    );
  }
  return <BrowserFrame src={src} alt={alt} className={className} />;
}
